'use strict';

/**
 * Loads all matching images within a given `containerEl`.
 * lazyLoadType: The type of "lazy load" image to target:
 *     "ondemandload": images will not load until manually called through a script.
 */
export function loadOnDemandImage(containerEl, lazyLoadType = 'ondemandload') {
    [].forEach.call(containerEl.querySelectorAll(`[data-image-component="${lazyLoadType}"]:not(.lazyloaded)`), function(currentImage) {
        window.lazySizes.loader.unveil(currentImage);
    });
}
